import { API_ENDPOINTS } from '@/utils/endpoints';
import { BaseService } from '../baseService';
import { Deficiency, Equipment, PolicyBilling } from '../models/Contracts';
import {
  CustomerByContractRequest,
  EquipmentRequest,
  PolicyBillingRequest,
} from '../models/BaseRequest';
import { Notes } from '../models/Notes';
import { NotesByContractRequest } from '../models/BaseRequest';
import { EventData, InsuranceRequest } from '@/utils/types';
import { ContractDetails } from '@/utils/types/contractDetails';

export class ContractDetailService {
  static fetchEquipments = async (payload: EquipmentRequest): Promise<Equipment[]> => {
    return await BaseService.post<Equipment[]>(API_ENDPOINTS.GET_EQUIPMENTS, payload);
  };

  static fetchPolicyBilling = async (payload: PolicyBillingRequest): Promise<PolicyBilling[]> => {
    return await BaseService.post<PolicyBilling[]>(
      API_ENDPOINTS.GET_POLICY_BILLING_DETAILS,
      payload,
    );
  };

  static fetchDeficiency = async (): Promise<Deficiency[]> => {
    return await BaseService.get<Deficiency[]>(API_ENDPOINTS.GET_DEFICIENCY_DETAILS);
  };

  static fetchContractDetails = async (
    request: CustomerByContractRequest,
  ): Promise<ContractDetails> => {
    return await BaseService.post<ContractDetails>(API_ENDPOINTS.GET_CONTRACT_DETAILS, request);
  };

  static fetchNotesDetails = async (request: NotesByContractRequest): Promise<Notes[]> => {
    return await BaseService.post<Notes[]>(API_ENDPOINTS.GET_NOTES_BY_CONTRACT, request);
  };

  static fetchInsuranceEventsList = async (request: InsuranceRequest): Promise<EventData[]> => {
    return await BaseService.post<EventData[]>(API_ENDPOINTS.GET_INSURANCE_DETAILS, request);
  };
}
